import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthCallback = () => {
  const navigate = useNavigate();

 useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const userName = params.get("userName");

  if (token) {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("userName", userName);
    navigate("/dashboard");
  } else {
    navigate("/login");
  }
}, [navigate]);


  return <p>Logging you in...</p>;
};

export default AuthCallback;
